import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useDispatch } from "react-redux";
import { setstateCartable } from "../../redux/activeState/activeStateAction";
import { ACTIVE_DIV, WORK_FLOW_TYPE } from "../../config/cacheKey";
import { useQueryClient } from "react-query";

const style = {
  width: "100%",
  maxWidth: 640,
  bgcolor: "background.paper",
};

export default function DividerCmp(props: any) {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const [active, setActive] = React.useState(0);
  const activeState = queryClient.getQueryData(ACTIVE_DIV);
  const [activeDiv, setActiveDiv] = React.useState<any>(0);
  const state = queryClient.getQueryData(WORK_FLOW_TYPE);
  React.useEffect(() => {
    setActiveDiv(activeState);
  }, [activeDiv]);
  // if (state != undefined) {
  //   setActive(0);
  // }
  queryClient.setQueryData(WORK_FLOW_TYPE, undefined);
  const typeHandle = (state: string, index: any) => {
    setActive(index);
    queryClient.setQueryData(ACTIVE_DIV, index);
    dispatch(setstateCartable({ stateCartable: state }));
    setActiveDiv(index);
  };
  return (
    <>
      <div
        style={{
          background: `${props.bgcolor}`,
          direction: "rtl",
          // borderRadius: "3px",
          // padding: "15px",
          // border: "1px solid rgba(0,0,0,.12)",
        }}
      >
        {props.data?.map((item: any, index: number, array: any) => {
          let flag = true;
          if (array.length - 1 === index) {
            flag = false;
          }

          return (
            <List
              className={
                index == (activeDiv ? activeDiv : 0)
                  ? "cursorPointer SuccessDefault colorFFF "
                  : "cursorPointer waitBGColor colorTitle "
              }
              sx={style}
              component="nav"
              aria-label="mailbox folders"
              key={index}
              style={{
                border: "1.5px solid #C1C7CB",
                borderRadius: "5px",
                marginTop: "6px",
                marginRight: "5px",
                padding: "5px",
                boxShadow: "0px .2px 2px 0px #DAE0E4",
                display: "inline-block",
                // maxWidth: "270px",
                height: "38px",
                width: "auto",
                minWidth: "17%",

                // background:`${item.stat}`
                // backgroundColor: active == index ? "black" : "white",
              }}
              onClick={(e) => typeHandle(item.state, index)}
            >
              <ListItem
                style={{
                  paddingRight: "10px",
                  display: "flex",
                  paddingTop: "0px",
                }}
                // onClick={() => props.onClick(item)}
              >
                <ListItemText
                  // className={item.stat=='success'? "colorFFF ":"colorTitle " }
                  style={{ textAlign: "right", fontWeight: "bolder" }}
                  primary={
                    <span
                      style={{
                        fontSize: "14px",
                        paddingRight: "5px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item.stateTitle}
                    </span>
                  }
                />
                <div
                  className="  badge badgeMe "
                  style={{ marginRight: "2vh" }}
                >
                  <div className="badgeMe1"> {item.count}</div>
                </div>
              </ListItem>
            </List>
          );
        })}
      </div>
    </>
  );
}
